export default class BrowserInspectionStorage {

  constructor(db) {
    this._db = db;
  }
}